import { render, staticRenderFns } from "./AwaitingApprovalList.vue?vue&type=template&id=2a5f1f35&scoped=true&"
import script from "./AwaitingApprovalList.vue?vue&type=script&lang=js&"
export * from "./AwaitingApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./AwaitingApprovalList.vue?vue&type=style&index=0&id=2a5f1f35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5f1f35",
  null
  
)

export default component.exports